import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { BaseFooter } from "../organisms/BaseFooter";
import { BaseHeader } from "../organisms/BaseHeader";
import { BaseSidebar } from "../organisms/BaseSidebar";
export const BaseLayout = ({ headerContent, footerContent, children, config, enableSidebarHover = true, handleIsExpanded, customSidebar, customSidebarOpen, isMobile, }) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [mobileViewport, setMobileViewport] = React.useState(false);
    useEffect(() => {
        if (handleIsExpanded) {
            handleIsExpanded(isExpanded);
        }
    }, [isExpanded]);
    useEffect(() => {
        if (isMobile !== undefined) {
            setMobileViewport(isMobile);
        }
    }, [isMobile]);
    useEffect(() => {
        if (customSidebarOpen !== undefined) {
            setIsExpanded(customSidebarOpen);
        }
    }, [customSidebarOpen]);
    return (_jsxs("div", { className: "relative min-h-screen bg-gray-50 dark:bg-gray-900", children: [_jsx("main", { className: `pb-16 pt-16 transition-all duration-300 ${isExpanded ? "ml-64" : mobileViewport ? "" : "ml-16"} ${mobileViewport && "ml-0"} dark:bg-gray-900`, children: _jsx("div", { children: children }) }), _jsx(BaseHeader, { isMobile: mobileViewport, isExpanded: isExpanded, children: headerContent }), _jsx(BaseFooter, { isMobile: mobileViewport, isExpanded: isExpanded, children: footerContent }), customSidebar !== null && customSidebar !== void 0 ? customSidebar : (_jsx(BaseSidebar, { isExpanded: isExpanded, onIsExpanded: handleIsExpanded, onToggle: () => setIsExpanded(!isExpanded), 
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                config: config, enableHover: enableSidebarHover }))] }));
};
export default BaseLayout;
